export default __webpack_public_path__ + "media/images/table_layouts/hexagonal-1ce05cf08fc1708714f5bceb15ab5a21.svg";